import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { CreateSocialMediaApi } from "../../../services/apis/EventMangement/CreateEventApi";
import facebookIcn from "../../../assets/images/SocialMedia/facebook.png";
import instagramIcn from "../../../assets/images/SocialMedia/instagram.png";
import LinkedinIcn from "../../../assets/images/SocialMedia/linkedin.png";
import TwitterIcn from "../../../assets/images/SocialMedia/twitter.png";
import SkypeIcn from "../../../assets/images/SocialMedia/skype.png";
import YoutubeIcn from "../../../assets/images/SocialMedia/youtube.png";
import WhatsAppIcn from "../../../assets/images/SocialMedia/whatsapp.png";
import WhatsAppBusinessIcn from "../../../assets/images/SocialMedia/whatsappbusiness.svg";
import Swal from "sweetalert2";

const SocialMedia = ({ eventId, setTabValue}) => {
    const [socialMedia, setSocialMedia] = useState({
        facebook: "",
        instagram: "",
        linkedin: "",
        twitter: "",
        youtube: "",
    });

    const [errors, setErrors] = useState({});

    // Regular expression for URL validation
    const urlRegex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/[\w.-]*)*\/?$/;

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setSocialMedia((prev) => ({
            ...prev,
            [name]: value,
        }));
        validateField(name, value);
    };

    // Validate individual fields
    const validateField = (name, value) => {
        let errorMsg = "";

        if (value.trim() && !urlRegex.test(value)) {
            errorMsg = "Please enter a valid URL (e.g., http://domain.com).";
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMsg,
        }));
    };

    // Validate the entire from
    const validateForm = () => {
        const newErrors = {};
        Object.keys(socialMedia).forEach((field) => {
            if (socialMedia[field].trim() && !urlRegex.test(socialMedia[field])) {
                newErrors[field] = "Please enter a valid URL (e.g., http://domain.com).";
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            console.log("Validation errors:", errors);
            return;
        }
        try {
            const response = await CreateSocialMediaApi(eventId, socialMedia);
            if (response?.data?.success) {
                toast.success(response?.data?.message, {
                 position: 'top-center'
                })
                setSocialMedia({
                  facebook: "",
                  instagram: "",
                  linkedin: "",
                  twitter: "",
                  youtube: "",
                });
                
                Swal.fire({
                  icon: "success",
                  title: "Event",
                  text: response?.data?.message,
                });
                setTabValue("Terms-Compliance")
            }
        } catch (error) {
            console.error("Error while submitting the form:", error);
        }

        // Proceed with form submission or API call
    };

    return (
        <>
            <ToastContainer />
            <div className="container-fluid my-0">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="mb-3 row">
                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label d-flex align-items-center gap-1">
                                <img src={facebookIcn} alt="fb" height={20}/>Facebook</label>
                                <input
                                    name="facebook"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.facebook}
                                    onChange={handleChange}
                                />
                                {errors.facebook && <small className="text-danger">{errors.facebook}</small>}
                            </div>

                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label d-flex align-items-center gap-1">
                                <img src={instagramIcn} alt="fb" height={20}/>Instagram</label>
                                <input
                                    name="instagram"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.instagram}
                                    onChange={handleChange}
                                />
                                {errors.instagram && <small className="text-danger">{errors.instagram}</small>}
                            </div>
                        </div>

                        <div className="mb-3 row">
                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label d-flex align-items-center gap-1">
                                <img src={LinkedinIcn} alt="fb" height={20}/>Linkedin</label>
                                <input
                                    name="linkedin"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.linkedin}
                                    onChange={handleChange}
                                />
                                {errors.linkedin && <small className="text-danger">{errors.linkedin}</small>}
                            </div>

                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label d-flex align-items-center gap-1">
                                <img src={TwitterIcn} alt="fb" height={20}/>Twitter</label>
                                <input
                                    name="twitter"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.twitter}
                                    onChange={handleChange}
                                />
                                {errors.twitter && <small className="text-danger">{errors.twitter}</small>}
                            </div>
                        </div>

                        <div className="mb-3 row">
                            <div className="col-md-6">
                                <label className="col-sm-6 col-form-label d-flex align-items-center gap-1">
                                <img src={YoutubeIcn} alt="fb" height={20}/>Youtube</label>
                                <input
                                    name="youtube"
                                    type="url"
                                    className="form-control"
                                    placeholder="Ex: http://domain.com/"
                                    value={socialMedia.youtube}
                                    onChange={handleChange}
                                />
                                {errors.youtube && <small className="text-danger">{errors.youtube}</small>}
                            </div>
                        </div>

                        <div className="d-flex justify-content-end gap-4 px-5">
                            <div className="create-event-back-btn">
                            <button className="btn btn-outline-primary" type="button"
                                    onClick={()=>setTabValue("Terms-Compliance")}>Skip</button>
                            </div>

                            <div className="">
                                <button type="submit" className="btn btn-primary">
                                    Save and Continue
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default SocialMedia;
